import { NotificationTypesEnum } from "../enums/NotificationTypesEnum";
import { AppNotification } from "./AppNotification";

export class UpdateResultNotification extends AppNotification {
    notificationType: NotificationTypesEnum = NotificationTypesEnum.Update;
    filename: string;

    constructor(data: any) {
        super(data);
        if (data.Filename) this.filename = data.Filename;
    }
}
